import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { TailwindColors } from "@vc-workspace/utils-colors";
import { Typography } from "@vc-workspace/utils-typography";
import { contentContainer, heroContainerStyles, heroImageStyles, imageStyles } from "./about-us-content.module.style";
/* eslint-disable-next-line */

export function AboutUsContent(props) {
  return _jsxs(_Fragment, {
    children: [_jsxs("div", {
      css: heroContainerStyles,
      children: [_jsx("img", {
        src: "/_mp-images/about_us_hero.svg",
        css: heroImageStyles
      }), !props.context.isMobileView ? _jsx(Typography, {
        type: "Heading2",
        color: TailwindColors.grey[700],
        className: "pl-56",
        semi_bold: true,
        children: "About Us"
      }) : null]
    }), _jsxs("div", {
      css: contentContainer,
      children: [_jsx(Typography, {
        type: props.context.isMobileView ? "Headline_H3" : "Heading2",
        color: "navy",
        className: "pt-11",
        semi_bold: true,
        children: "Mission"
      }), _jsx(Typography, {
        type: props.context.isMobileView ? "Body1" : "Headline_H3",
        color: TailwindColors.blueGrey[800],
        className: "pt-4",
        children: "Before shopping was a matter of a few clicks, it was a venture of bringing something home.A jar of pickle, handmade silver jewellery or a silk saree that gets passed on generations - when we bought something, we brought its culture with us."
      }), _jsx(Typography, {
        type: props.context.isMobileView ? "Body1" : "Headline_H3",
        color: TailwindColors.blueGrey[800],
        className: "pt-4",
        children: "Vibecity believes in bringing together passionate creators and people looking for products with stories. We are keeping alive the spirit of craftsmanship through customers who are in search of alternatives to fast commerce. From artisans and craftsmen to simply anyone who loves to create - all of them come together at Vibecity to make a place where creativity comes first."
      }), _jsx(Typography, {
        type: props.context.isMobileView ? "Body1" : "Headline_H3",
        color: TailwindColors.blueGrey[800],
        className: "pt-4",
        children: "Vibecity is about taking shopping back to its roots. It\u2019s a marketplace where a community of creators trade their skills and craft to appreciating customers.We are online, but entirely human."
      }), _jsx(Typography, {
        type: props.context.isMobileView ? "SubHeading1" : "Heading3",
        color: "navy",
        className: "pt-11",
        semi_bold: true,
        children: "Our Partners"
      }), _jsxs("div", {
        className: "flex flex-row items-center justify-start pt-8",
        children: [_jsx("img", {
          src: "https://s3.ap-south-1.amazonaws.com/cdn.flynote.in/vibecity/investors/IQ.jpg",
          css: imageStyles
        }), _jsx("img", {
          src: "https://s3.ap-south-1.amazonaws.com/cdn.flynote.in/vibecity/investors/sequoia_new_logo_black.png",
          css: imageStyles,
          className: "ml-8"
        })]
      })]
    })]
  });
}
export default AboutUsContent;